import {
  START,
  SUCCESS,
  ERROR,
  SAVE_USER,
  GET_USER,
  GET_USERS,
  CLEAN_USERS,
  DELETE_USER,
  GET_PROFILE,
  SET_RELOAD_USERS,
  SET_USER_FILTERS,
  SET_CURRENT_USER_STEP,
  ADD_COMPLETED_USER_STEPS, SET_COMPLETED_USER_STEPS, SET_USER_ATTRIBUTES
} from '../actions/types';
import { getError } from '../../utils/requestUtils';
import { updateAttributesInItem } from '../utils';
import { updateItemInItems } from '../../utils/arrayUtils';

const INITIAL_STATE = {
  users: [],
  user: null,
  currentUser: null,
  pagination: null,
  reloadUsers: false,
  filters: {},
  currentStep: null,
  completedSteps: [],

  getUsers: {},
  getUser: {},
  saveUser: {},
  deleteUser: {}
};

export default function reducer(state = INITIAL_STATE, action) {
  const data = action.payload?.data;
  const error = getError(action.payload);
  let user;

  switch (action.type) {
    case GET_USERS + START:
      return { ...state, getUsers: { loading: true } };
    case GET_USERS + SUCCESS:
      return {
        ...state,
        getUsers: { loading: false },
        users: data.result.items,
        pagination: data.result.pagination
      };
    case GET_USERS + ERROR:
      return { ...state, getUsers: { loading: false, error } };

    case CLEAN_USERS + SUCCESS:
      return {
        ...state, getUsers: { loading: false }, users: [], pagination: null
      };

    case GET_PROFILE + START:
      return { ...state, getProfile: { loading: true } };
    case GET_PROFILE + SUCCESS:
      return { ...state, getProfile: { loading: false }, currentUser: data.profile };
    case GET_PROFILE + ERROR:
      return { ...state, getProfile: { loading: false, error: action.payload } };

    case GET_USER + START:
      return { ...state, getUser: { loading: true } };
    case GET_USER + SUCCESS:
      return { ...state, getUser: { loading: false }, user: data.item };
    case GET_USER + ERROR:
      return { ...state, getUser: { loading: false, error } };

    case SAVE_USER + START:
      return { ...state, saveUser: { loading: true } };
    case SAVE_USER + SUCCESS:
      return { ...state, saveUser: { loading: false }, user: data.item };
    case SAVE_USER + ERROR:
      return { ...state, saveUser: { loading: false, error } };

    case DELETE_USER + START:
      return { ...state, deleteUser: { loading: true } };
    case DELETE_USER + SUCCESS:
      return {
        ...state,
        deleteUser: { loading: false },
        users: state.users.filter((m) => m.id !== data.item.id)
      };
    case DELETE_USER + ERROR:
      return { ...state, deleteUser: { loading: false, error } };

    case SET_RELOAD_USERS:
      return { ...state, reloadUsers: action.payload.reload };

    case SET_USER_FILTERS:
      return { ...state, filters: action.payload.filters };

    case SET_CURRENT_USER_STEP:
      return { ...state, currentStep: action.payload.step };

    case SET_COMPLETED_USER_STEPS:
      return { ...state, completedSteps: action.payload.steps };

    case ADD_COMPLETED_USER_STEPS:
      return {
        ...state,
        completedSteps:
          [...new Set([...state.completedSteps, ...action.payload.steps])]
      };

    case SET_USER_ATTRIBUTES:
      user = updateAttributesInItem(state.user, action.payload.userId, action.payload.attributes);
      return {
        ...state,
        user,
        users: updateItemInItems(state.users, user),
      };

    default:
      return { ...state };
  }
}
